const DOJO_EXERCISE_ACTION = {
    BEAT: 'beat',
    VERIFY: 'verify',
    SKIP: 'skip',
    AUTO_SAVE: 'auto_save',
    SAVE: 'save',
    SUBMIT: 'submit',
    RUN: 'run',
    LOG: 'log',
}

export default DOJO_EXERCISE_ACTION
